export default __webpack_public_path__ + "static/media/image.camellia-network.e0ff64b1.png";